import { IClient, IClientResponse } from '../types/clientABM.type';
import $http from '../services/AxiosInstance';

interface Params {
  page?: number;
  search?: string;
  deleted?: boolean;
  typePolicyTransport?: string;
}

export interface IMinifiedClient {
  id: string;
  tradeName: string;
}

export interface IMinifiedClientsResponse {
  clients: IMinifiedClient[];
  pagination: {
    count: number;
    current_page: number;
    has_next_page: boolean;
    page_count: number;
  };
}

export interface IOperationClient {
  id: number;
  tradeName: string;
}

export interface IOperationClientsResponse {
  clients: IOperationClient[];
  pagination: IMinifiedClientsResponse['pagination'];
}

class ClientsABMRepository {
  static async getClients(allClients: boolean = false) {
    try {
      const response = await $http.get('/clients', { params: allClients ? { flag: 'all' } : {} });
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }

  static async getClientsProPaginated(params: Params = {}): Promise<IClientResponse> {
    try {
      if (params.search && params.search.trim() === '') {
        params.search = undefined;
      }
      let url = `/clients/pro`;
      if (params.page) {
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `${params.page ? '&' : '?'}search=${encodeURIComponent(params.search)}`;
      }
      if (params.deleted) {
        url += `${params.page || params.search ? '&' : '?'}deleted=${params.deleted}`;
      }
      const { data: { data: dataResponse } } = await $http.get(url);
      return dataResponse;
    } catch (errors: any) {
      throw Error;
    }
  }

  static async getMinifiedClients(params: Params = {}): Promise<IMinifiedClientsResponse> {
    const search = params.search?.trim() || undefined;
    const { data: { data } } = await $http.get('/integrations/clients/minified', {
      params: {
        page: params.page ?? 1,
        search,
        typePolicyTransport: params.typePolicyTransport,
      },
    });
    return data;
  }

  static async getOperationClients(params: Params = {}): Promise<IOperationClientsResponse> {
    const search = params.search?.trim() || undefined;
    const { data: { data } } = await $http.get('/clients/operations/minified', {
      params: {
        page: params.page ?? 1,
        search,
        typePolicyTransport: params.typePolicyTransport,
      },
    });
    return data;
  }

  static async createClient(data: IClient): Promise<IClient> {
    try {
      const response = await $http.post('/clientsABM', data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }

  static async updateClient(data: IClient): Promise<IClient> {
    try {
      const response = await $http.patch(`/clients/${data.id}`, data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }

  static async deleteClient(id: number): Promise<void> {
    try {
      if (!id || id <= 0) {
        throw new Error('ID del cliente inválido');
      }
      const response = await $http.delete(`/clients/${id}`);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }

  static async restoreClient(id: number): Promise<IClient> {
    try {
      if (!id || id <= 0) {
        throw new Error('ID del cliente inválido');
      }
      const response = await $http.patch(`/clients/${id}/restore`, {});
      return response.data;
    } catch (error) {
      throw Error;
    }
  }

  static async getClientById(id: number): Promise<IClient> {
    try {
      if (!id || id <= 0) {
        throw new Error('ID del cliente inválido');
      }
      const response = await $http.get(`/clients/${id}`);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
}

export default ClientsABMRepository;
